import React, { useState, useEffect, createRef } from 'react';
import { useHistory } from 'react-router-dom';
import CardContainer from '../../../components/card/card-container.jsx';
import ListToolbar, { BtnNuevo, BtnSecundario, BtnEliminar } from '../../../nuup/componentes/Toolbar/ListToolbar.jsx';
import ModalAsignarLote from './modals/modal-asignar-lote.jsx';
import ModalNuevoLote from './modals/modal-nuevo-lote.jsx';
import ModalInfoLote from './modals/modal-info-lote.jsx';
import Api from '../../../api/global.service';
import { useAuth } from '../../../components/content/auth.jsx';
import env from '../../../environment.js';
import Swal from 'sweetalert2';
import SelectCiclo from '../../../components/select/select-ciclo.jsx';
import { subscribe, unsubscribe } from '../../../components/events';
import './entregas-x-lote.css';
import ModalCambiarEstado from './modals/modal-cambiar-estado.jsx';
// import LotesGraficaEstatus from './components/lotes-grafica-estatus.js';
import LotesExport from './components/lotes-export.js';
import LotesTable from './components/lotes-table.js';
import { useCoopConfig } from '../../../components/content/coop-config.jsx';
import SearchColumn from '../../../components/search/search-column.jsx';
import IDs_WHISP from '../../../constants/IdsWhisp.js';
import LinkDownloadExcel from '../../../components/link/link-download-excel.jsx';
import insertIf from '../../../utils/insertIf.js';

const EntregasXLoteList = () => {
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const [lotes, setLotes] = useState([]);
  const [idLote, setIdLote] = useState(0);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const dialogAsignarLote = createRef();
  const dialogNuevoLote = createRef();
  const dialogInfoLote = createRef();
  const dialogCambiarEstado = createRef();
  const [dataLotes, setDataLotes] = useState([]);
  const [dataLotesWithEudr, setDataLotesWithEudr] = useState([]);
  const [infoLote, setInfoLote] = useState({});
  const [estados, setEstados] = useState([]);
  const [showInfoLote, setShowInfoLote] = useState(false);
  const [showNuevoLote, setShowNuevoLote] = useState(false);
  const [cicloActual, setCicloActual] = useState(null);

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'nombre', label: 'NOMBRE' },
      { value: 2, target: 'folio', label: 'CÓDIGO' },
      ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
        value: 3,
        target: 'volumen',
        label: 'TOTAL',
      }),
      ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
        value: 3,
        target: 'volumen_extra',
        label: 'TOTAL',
      }),
      ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
        value: 4,
        target: 'lote_kgs_por_entregar',
        label: 'VOLUMEN POR ENTREGAR',
      }),
      ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
        value: 4,
        target: 'lote_kgs_por_entregar_extra',
        label: 'VOLUMEN POR ENTREGAR',
      }),
      ...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
        value: 5,
        target: 'lote_kgs_entregados',
        label: 'VOLUMEN ACOPIADO',
      }),
      ...insertIf(coopConfig.hasAcopioUnitsExtra(), {
        value: 5,
        target: 'lote_kgs_entregados_extra',
        label: 'VOLUMEN ACOPIADO',
      }),
      { value: 6, target: 'avance_acopio', label: 'AVANCE ACOPIO' },
      {
        value: 7,
        target: 'nombre_recoleccion_acopio_estatus',
        label: 'ESTADO',
      },
      { value: 8, target: 'observaciones', label: 'OBSERVACIONES' },
      { value: 9, target: 'fecha_entrega_venta', label: 'FECHA ENTREGA VENTA' },
      { value: 10, target: 'riesgo_eudr', label: 'RIESGO EUDR' },
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        value: 11,
        target: 'id_muestra',
        label: 'ID MUESTRA',
      }),
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        value: 12,
        target: 'nombre_tipo_muestra',
        label: 'TIPO DE MUESTRA',
      }),
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        value: 13,
        target: 'rendimiento_bruto',
        label: 'RENDIMIENTO BRUTO (%)',
      }),
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        value: 14,
        target: 'rendimiento_exportable_por',
        label: 'RENDIMIENTO EXPORTABLE (%)',
      }),
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        value: 15,
        target: 'rendimiento_real',
        label: 'RENDIMIENTO REAL (%)',
      }),
    ],
    []
  );

  useEffect(() => {
    if (ciclo.id) {
      dialogAsignarLote.current.setIdCiclo(ciclo.id);
      dialogCambiarEstado.current.setIdCiclo(ciclo.id);
      getLotes();
    }
  }, [ciclo]);

  useEffect(() => {
    if (ciclo.id > 0) {
      filtrarPorLote();
    }
  }, [idLote, showInfoLote]);

  useEffect(() => {
    if (dataLotes.length > 0 && originalData.length > 0) {
      setDataLotesWithEudr(
        dataLotes.map(it => {
          const maxRisk = originalData.reduce((max, d) => {
            if (Number(d.id_lote) === Number(it.id)) {
              if (d.riesgo_eudr && !isNaN(Number(d.riesgo_eudr)) && Number(d.riesgo_eudr) < Number(max)) {
                return Number(d.riesgo_eudr);
              }
            }
            return max;
          }, IDs_WHISP.SIN_ASIGNAR);
          return {
            ...it,
            riesgo_eudr: maxRisk,
          };
        })
      );
    }
  }, [dataLotes, originalData]);

  useEffect(() => {
    setCicloActual(coopConfig?.activeCicloAcopio()?.id);

    subscribe('Lote::onSave', e => handleSave(e));
    subscribe('LoteAsignado::onSave', e => handleSaveAsignado(e));
    subscribe('CambioEstado::onSave', e => handleCambioEstado(e));
    getEstados();
    return () => {
      unsubscribe('Lote::onSave');
      unsubscribe('LoteAsignado::onSave');
      unsubscribe('CambioEstado::onSave');
    };
  }, []);

  const setFilter = value => {
    setCiclo(value.target);
    updateData(value.target.id);
  };

  const filtrarPorLote = () => {
    if (idLote > 0) {
      setData(originalData.filter(d => Number(d.id_lote) === Number(idLote)));
    } else {
      setData(originalData);
    }
  };

  const updateData = id_ciclo => {
    setBlocking(true);
    let filter = [{ column: 'id_ciclo', operator: '=', value: id_ciclo }];
    if (idLote > 0) {
      filter.push({ column: 'id_lote', operator: '=', value: idLote });
    }
    Api.Acopio.search('entregas_por_productor', { filter: filter })
      .then(async response => {
        let _data = response.data;
        setOriginalData(_data);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error', e);
        setBlocking(false);
      });
  };

  const setDataFilter = data => {
    setDataLotesWithEudr(data);
  };

  const handleSave = event => {
    //setIds([]);

    Swal.fire({
      icon: 'success',
      title: '',
      text: `Se registró con éxito el lote ${event.detail.nombre}.`,
    });
    getLotes();
  };

  const handleSaveAsignado = event => {
    setIdsSeleccionados([]);
    Swal.fire({
      icon: 'success',
      title: '',
      text: `Entregas asociadas al lote seleccionado.`,
    });
    setIdLote(0);
    getLotes();
    updateData(event.detail.id_ciclo);
  };

  const handleCambioEstado = event => {
    setIdsSeleccionados([]);
    Swal.fire({
      icon: 'success',
      title: '',
      text: `Cambio de estado realizado.`,
    });
    setIdLote(0);
    updateData(event.detail.id_ciclo);
  };

  const getLotes = () => {
    Api.get('admin/acopios/entregas/lotes', localStorage.getItem(`${env.appName}-ciclo_id`), {})
      .then(response => {
        let lotes = response.data;
        setDataLotes(lotes);
        setDataLotesWithEudr(lotes);
        setLotes(
          lotes.map(function(lote) {
            return { label: lote.nombre, value: lote.id };
          })
        );
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
      });
  };

  const getSelectedLote = (_idLote = idLote) => {
    if (_idLote > 0) {
      const _lote = dataLotesWithEudr.filter(lote => Number(lote.id) === Number(_idLote));
      return _lote[0];
    }
    return null;
  };

  const exportarXlsx = () => {
    LotesExport(dataLotesWithEudr, ciclo, estados, coopConfig);
  };

  const handleNavigateToLoteDetails = id_lote => {
    const lote = getSelectedLote(id_lote);
    if (lote) {
      history.push(`/admin/acopio/lotes/${lote.uuid}`, {
        id_lote: id_lote,
      });
    }
  };

  const handleNuevoLote = () => {
    setShowNuevoLote(true);
  };

  useEffect(() => {
    setData(originalData);
  }, [originalData]);

  const handlerSelectChange = (selectedOption, uuid) => {
    setBlocking(true);
    Api.update('admin/acopios/lotes/cambia_estado_lote', uuid, {
      id_recoleccion_acopio_estatus: selectedOption.value,
    })
      .then(() => {
        getLotes();
        setBlocking(false);
      })
      .then(() => {
        setBlocking(true);
        updateData(ciclo.id);
        setBlocking(false);
      })
      .catch(e => {
        setBlocking(false);
        console.error('Error actualizando estado:', e);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cambiar el estado. Inténtalo de nuevo.',
        });
      });
  };

  const resetLotes = () => {
    setIdLote(0);
  };

  const getEstados = () => {
    Api.getAll('acopios/catalogos/recoleccion_acopios_estatus')
      .then(response => {
        let estados = response.data;
        setEstados(
          estados.map(function(estado) {
            return {
              label: estado.nombre,
              value: estado.id,
              color: estado.color,
            };
          })
        );
      })
      .catch(e => {
        // eslint-disable-next-line no-console
      });
  };
  const eliminarLote = () => {
    setBlocking(true);
    const warningText =
      data.length > 0
        ? 'El lote tiene entregas vinculadas. Al eliminar el lote NO se eliminarán las entregas, sólo la información del lote'
        : 'El registro de lote seleccionado se eliminará';

    Swal.fire({
      title: '',
      icon: 'warning',
      text: warningText,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      confirmButtonColor: '#FF5733',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#f4f4f4',
    }).then(result => {
      if (result.isConfirmed) {
        Api.delete('admin/acopios/lotes', idLote)
          .then(response => {
            if (response.data.success === 1) {
              Swal.fire({
                icon: 'success',
                title: '',
                text: 'Se eliminó el lote seleccionado.',
              });
              resetLotes();
              getLotes();

              //esto pudo ser un updateData(ciclo), pero esta función se llama cuando idLote no ha cambiado a 0
              let filter = [{ column: 'id_ciclo', operator: '=', value: ciclo }];
              Api.Acopio.search('entregas_por_productor', { filter: filter })
                .then(async response => {
                  let _data = response.data;
                  setOriginalData(_data);
                  setBlocking(false);
                })
                .catch(err => {
                  console.error(err);
                });
            }
          })
          .catch(error => {
            if (error.response) {
              setBlocking(false);
              Swal.fire({
                title: 'Error',
                icon: 'error',
                text: error.response.data.message || 'Acceso prohibido',
              });
            } else {
              // eslint-disable-next-line no-console
              console.error('error: ', error);
              setBlocking(false);
            }
          });
      } else {
        setBlocking(false);
      }
    });
  };

  const handleInfoModalClose = () => {
    setShowInfoLote(false);
  };

  const handleNuevoModalClose = () => {
    setShowNuevoLote(false);
  };

  return (
    <div>
      <div className="row justify-content-between mb-2">
        <div className="col-2">
          <SelectCiclo
            width="150px"
            setFilter={evt => {
              setFilter(evt);
            }}
            acopio
          />
        </div>
        <div className="col-2 offset-1 poquitoAbajo">
          {ciclo?.uuid && auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_EXPORTAR') && (
            <div className="d-flex justify-content-end mr-3">
              <LinkDownloadExcel handleExport={exportarXlsx} />
            </div>
          )}
        </div>
      </div>

      <CardContainer height={'100%'}>
        <ListToolbar left={<SearchColumn data={dataLotes} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
          <BtnNuevo
            show={idLote === 0 && ciclo && ciclo?.id == cicloActual}
            onClick={() => {
              setInfoLote({});
              setShowInfoLote(false);
              setShowNuevoLote(true);
            }}>
            Nuevo lote
          </BtnNuevo>
          <BtnSecundario show={ciclo && ciclo?.id == cicloActual} onClick={() => handleNuevoLote()} disabled={idLote === 0}>
            Editar lote
          </BtnSecundario>
          <BtnEliminar show={ciclo && ciclo?.id == cicloActual} onClick={() => eliminarLote()} disabled={idLote === 0}>
            Eliminar lote
          </BtnEliminar>
        </ListToolbar>

        <LotesTable
          data={dataLotesWithEudr}
          blocking={blocking}
          idLote={idLote}
          setIdLote={setIdLote}
          setInfoLote={setInfoLote}
          handleNavigateToLoteDetails={handleNavigateToLoteDetails}
          estados={estados}
          handlerSelectChange={handlerSelectChange}
        />
      </CardContainer>

      {/* <div className="mt-3">
        <CardContainer height={'100%'}>
          <LotesGraficaEstatus data={data} />
        </CardContainer>
      </div> */}

      <ModalAsignarLote
        lotes={lotes}
        entregas={idsSeleccionados}
        ref={dialogAsignarLote}
        title="Asignar entregas a lote"></ModalAsignarLote>
      <ModalCambiarEstado entregas={idsSeleccionados} ref={dialogCambiarEstado} title="Cambiar estado de entregas"></ModalCambiarEstado>
      {showNuevoLote && (
        <ModalNuevoLote
          ref={dialogNuevoLote}
          infoLote={infoLote ? infoLote : {}}
          idLote={idLote}
          onClose={handleNuevoModalClose}
          show={showNuevoLote}
          cicloActual={cicloActual}></ModalNuevoLote>
      )}
      {showInfoLote && <ModalInfoLote ref={dialogInfoLote} idLote={idLote} onClose={handleInfoModalClose} title="" />}
    </div>
  );
};

export default EntregasXLoteList;
